import {
  Box,
  CircularProgress,
  Button as MuiButton,
  Card as MuiCard,
  Grid as MuiGrid,
} from '@mui/material'
// biome-ignore lint/style/useImportType: <This is not a type only import>
import React from 'react'

export const Loader: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="200px"
  >
    <CircularProgress />
    {children}
  </Box>
)

export const Image: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = (
  props,
) => <img {...props} alt={props.alt ?? ''} />

export const Divider: React.FC = () => (
  <div style={{ borderBottom: '1px solid #e0e0e0', margin: '16px 0' }} />
)

export const Button: React.FC<React.ComponentProps<typeof MuiButton>> = (
  props,
) => <MuiButton {...props} />

export const Card: React.FC<React.ComponentProps<typeof MuiCard>> = (props) => (
  <MuiCard {...props} />
)

export const Grid: React.FC<React.ComponentProps<typeof MuiGrid>> = (props) => (
  <MuiGrid {...props} />
)

export const Modal: React.FC<{
  children: React.ReactNode
  open: boolean
  onClose: () => void
}> = ({ children, open, onClose }) => {
  if (!open) return null
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          padding: 4,
          borderRadius: 2,
          maxWidth: 600,
          width: '90%',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </Box>
    </Box>
  )
}

export const Icons = {
  Close: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M18 6L6 18M6 6l12 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <title>Close</title>
    </svg>
  ),
  CheckMark: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M9 12l2 2 4-4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <title>Check Mark</title>
    </svg>
  ),
}
